import { Check } from "lucide-react";
import { Reveal, RevealStagger, staggerItem } from "@/components/Reveal";
import { motion } from "framer-motion";
import { whyPoints, images } from "@/data/content";

export default function WhyChoose() {
  return (
    <section id="why" className="py-14 lg:py-20 aqua-gradient" data-testid="why-section">
      <div className="mx-auto max-w-7xl px-5 grid lg:grid-cols-2 gap-14 items-center">
        <Reveal>
          <div className="relative rounded-[2rem] overflow-hidden shadow-[0_24px_60px_rgba(15,58,112,0.14)] aspect-[4/3]">
            <img
              src={images.familyTap}
              alt="Pristine Water Systems specialist explaining a home water filtration system to local homeowners"
              className="w-full h-full object-cover"
            />
          </div>
        </Reveal>

        <div>
          <Reveal>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-pristine-aquadeep mb-4">Why Pristine</p>
            <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-medium text-pristine-navy tracking-tight text-balance">
              Why Sunshine Coast Homeowners Choose Pristine
            </h2>
          </Reveal>

          <RevealStagger className="mt-9 grid sm:grid-cols-2 gap-x-6 gap-y-4">
            {whyPoints.map((p) => (
              <motion.div key={p} variants={staggerItem} className="flex items-start gap-3">
                <span className="mt-0.5 inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-pristine-blue">
                  <Check className="h-3.5 w-3.5 text-white" strokeWidth={3} />
                </span>
                <span className="text-sm text-pristine-navy/80 leading-relaxed">{p}</span>
              </motion.div>
            ))}
          </RevealStagger>
        </div>
      </div>
    </section>
  );
}
